import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiLeetcode} from 'react-icons/si'
import {BsInstagram} from 'react-icons/bs'
import {BsMedium} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/abdullahsattar4/' target='_blank' rel='noreferrer'><BsLinkedin/></a>
        <a href='https://github.com/abdullahsattaar' target='_blank' rel='noreferrer'><FaGithub/></a>
        <a href='https://leetcode.com/u/abdullahsattar' target='_blank' rel='noreferrer'><SiLeetcode/></a>
        <a href='https://www.instagram.com/abdullahsattaar/' target='_blank' rel='noreferrer'><BsInstagram/></a>
        <a href='https://medium.com/@abdullahsattaar' target='_blank' rel='noreferrer'><BsMedium/></a>
        
    </div>
  )
}

export default HeaderSocials